import { render, staticRenderFns } from "./FindInLayers.vue?vue&type=template&id=1becf1b4&scoped=true"
import script from "./FindInLayers.vue?vue&type=script&lang=ts&setup=true"
export * from "./FindInLayers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FindInLayers.vue?vue&type=style&index=0&id=1becf1b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1becf1b4",
  null
  
)

export default component.exports